import { createSelector } from 'reselect'

const getState = state => state.MyFiles

const getFetchMyFilesRequest = state => getState(state).fetchMyFilesRequest

const getMyFiles = state => getState(state).files

const getMyFilesResult = createSelector(
  [getMyFiles],
  files => (!files ? [] : files.result)
)

const getMyFilesMap = createSelector(
  [getMyFiles],
  files => (!files ? {} : files.entities.files)
)

const getMyFilesList = createSelector(
  [getMyFilesResult, getMyFilesMap],
  (result, filesMap) => result.map(id => filesMap[id])
)

const getMyFile = (state, id) => getMyFilesMap(state)[id]

const getPagination = state => getState(state).pagination

export {
  getMyFiles,
  getMyFilesList,
  getFetchMyFilesRequest,
  getMyFile,
  getPagination
}
